import { Path } from '@common/constans/Path';
import { IAgenda } from '@common/models/CMS/Agenda';
import { Card, CardContent, CardMedia } from '@components/general/card';
import Button from '@components/general/form/Button';
import Label from '@components/general/Label';
import Translate from '@service/Translate';
import { formatToDate } from '@utilize/Format';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';

export interface IAgendaItemProps {
    data: IAgenda;
}

const AgendaItem: FC<IAgendaItemProps> = ({ data }) => {
    const { push } = useHistory();
    const { tr } = Translate;

    const onShareAgendaClick = () => {
        navigator
            .share({
                title: tr("mahan_air"),
                text: `${data.displayText}\n${tr("publish_date")}: ${formatToDate(Number(new Date(data.startTime || "")), { format: "d M Y" })}`,
                url: `${window.location}/${data.localization?.localizationSet}`
            })
            .then(() => {
                console.log('Successfully shared');
            })
            .catch(error => {
                console.error('Something went wrong sharing the blog', error);
            });
    }

    return (
        <Card variant="vertical">
            <CardMedia
                source={data.cover || { paths: [], texts: [] }}
                onClick={() => push(`${Path.Tourism.AgendaDetail}/${data.localization?.localizationSet}`)}
            />
            <CardContent>
                <section className="section-header flex">
                    <h2
                        className="card-header"
                        onClick={() => push(`${Path.Tourism.AgendaDetail}/${data.localization?.localizationSet}`)}
                    >
                        {data.displayText}
                    </h2>
                    <div className="btn-action flex">
                        <Button
                            icon="icon-whatsapp desktop"
                            width="25px"
                            height="25px"
                            target="_blank"
                            url={`https://wa.me?text=${encodeURIComponent(
                                `*${tr("mahan_air")}*\n` +
                                `${data.displayText}\n` +
                                `_${tr("publish_date")}: *${formatToDate(new Date(data.startTime || 0).getTime(), { format: "d M Y" })}*_\n\n` +
                                `${window.location}/${data.localization?.localizationSet}`
                            )}`}
                            rounded
                        />
                        <Button
                            icon="icon-news-telegram desktop"
                            width="25px"
                            height="25px"
                            target="_blank"
                            url={`https://t.me/share/url?url=` +
                                encodeURIComponent(
                                    `**${tr("mahan_air")}**\n` +
                                    `${data.displayText}\n` +
                                    `${tr("publish_date")}: **${formatToDate(new Date(data.startTime || 0).getTime(), { format: "d M Y" })}**\n\n` +
                                    `${window.location}/${data.localization?.localizationSet}`
                                )}
                            rounded
                        />
                        <Button
                            className="share mobile"
                            icon="icon-share"
                            width="25px"
                            height="25px"
                            target="_blank"
                            onClick={() => onShareAgendaClick()}
                            rounded
                        />
                    </div>
                </section>
                <section className="agenda-property">
                    <Label mode="inline" icon="icon-map-marker-outline" text={data.city?.contentItems[0]?.name!} />
                    <Label mode="inline" icon="icon-calendar-outline" text={formatToDate(new Date(data.startTime || 0).getTime()) || ""} />
                </section>
            </CardContent>
        </Card>
    );
}

export default AgendaItem;
